import React, { createContext, useContext, useEffect, useState } from 'react';

import * as Ably from 'ably';

// Tạo Context
const WebSocketContext = createContext(null);

// Provider Component
export const WebSocketProvider = ({ children }) => {
  // State để lưu Ably client instance
  const [ablyClient, setAblyClient] = useState(null);
  // State để theo dõi trạng thái kết nối Ably
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Lấy Ably API Key từ biến môi trường
    // Đảm bảo bạn đã cấu hình biến môi trường REACT_APP_ABLY_API_KEY
    const ablyApiKey = process.env.REACT_APP_ABLY_API_KEY;

    if (!ablyApiKey) {
      console.error('Ably API key is not set in environment variables (REACT_APP_ABLY_API_KEY).');
      // Có thể thêm logic hiển thị lỗi cho người dùng hoặc dừng lại
      return;
    }

    // Khởi tạo Ably client
    const client = new Ably.Realtime({ key: ablyApiKey });

    // Lắng nghe các sự kiện kết nối
    client.connection.on('connected', () => {
      console.log('Ably connected successfully!');
      setIsConnected(true);
    });

    client.connection.on('disconnected', () => {
      console.log('Ably disconnected.');
      setIsConnected(false);
    });

    client.connection.on('closed', () => {
      console.log('Ably connection closed.');
      setIsConnected(false);
    });

    client.connection.on('failed', (error) => {
      console.error('Ably connection failed:', error);
      setIsConnected(false);
      // Xử lý lỗi kết nối, ví dụ: hiển thị thông báo cho người dùng
    });

    // Lưu client vào state
    setAblyClient(client);

    // Cleanup function: đóng kết nối Ably khi component unmount
    return () => {
      if (client) {
        console.log('Closing Ably connection...');
        client.close();
      }
    };
  }, []); // Dependency rỗng để effect chỉ chạy một lần khi component mount

  // Cung cấp ablyClient và trạng thái kết nối qua Context
  return <WebSocketContext.Provider value={{ ablyClient, isConnected }}>{children}</WebSocketContext.Provider>;
};

// Hook tùy chỉnh để sử dụng Context
export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  if (context === null) {
    // Đây là lỗi nếu hook được sử dụng bên ngoài WebSocketProvider
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};

// Alias hook để tương thích với useAblyChannel
export const useAbly = () => {
  const { ablyClient } = useWebSocketContext();
  return ablyClient;
};
